export function getVideoId(url: string): string | null {
  try {
    // Clean and decode the URL
    const cleanUrl = decodeURIComponent(url.trim());

    // Direct video ID check (11 characters)
    if (/^[a-zA-Z0-9_-]{11}$/.test(cleanUrl)) {
      return cleanUrl;
    }

    // Try to create URL object
    let urlObj: URL;
    try {
      urlObj = new URL(cleanUrl);
    } catch {
      // If URL parsing fails, try regex match as last resort
      const match = cleanUrl.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([^&?\/]+)/);
      return match ? match[1] : null;
    }

    // Extract video ID based on URL format
    let videoId: string | null = null;

    if (urlObj.hostname === 'youtu.be') {
      // Format: youtu.be/VIDEO_ID
      videoId = urlObj.pathname.slice(1);
    } else if (urlObj.hostname.includes('youtube.com')) {
      if (urlObj.pathname.startsWith('/embed/')) {
        // Format: youtube.com/embed/VIDEO_ID
        videoId = urlObj.pathname.split('/')[2];
      } else if (urlObj.pathname.startsWith('/shorts/')) {
        // Format: youtube.com/shorts/VIDEO_ID
        videoId = urlObj.pathname.split('/')[2];
      } else {
        // Format: youtube.com/watch?v=VIDEO_ID
        videoId = urlObj.searchParams.get('v');
      }
    }

    // Clean up any remaining parameters (like ?si=...)
    if (videoId?.includes('?')) {
      videoId = videoId.split('?')[0];
    }

    // Validate video ID format
    return videoId && /^[a-zA-Z0-9_-]{11}$/.test(videoId) ? videoId : null;
  } catch {
    return null;
  }
} 